export default "__VITE_ASSET__DW$F30Zl__"